// extracted by mini-css-extract-plugin
module.exports = {"topbar":"style_topbar__21Vtj","logoContainer":"style_logoContainer__eBxr2","logo":"style_logo__S-1h-","name":"style_name__jp58M","descr":"style_descr__1UFTi"};